/* eslint-disable */

<template>
    <div class="ma-0 pa-0">
        <BasicCard :show_title="false">
            <div>
                <v-container>
                    <!--v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-top mt-4">
                            <div>
                                <div class="text-h6">Ente emettitore certificati</div>
                                <div v-if="def_orgs.length>0"><span v-for="org of def_orgs" :key="org._id"><b>{{org.value.name}}</b> - {{org.value.piva}}<br/></span></div>
                                <div v-else class="font-italic">Nessun ente selezionato</div>
                            </div>
                            <v-btn v-can="{obj_type:'organism', action: 'edit'}" class="d-flex" color="primary" @click="openDefOrgsDialog"><v-icon class="pa-2" small>add_box</v-icon><span v-if="def_orgs.length>0">cambia</span><span v-else>imposta</span></v-btn>
                        </v-col>
                    </v-row-->
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-center mt-4">
                            <v-text-field
                                dense outlined
                                label="cerca tra gli enti"
                                v-model="filter.search"
                                prepend-icon="search"
                                clearable
                                hide-details
                            ></v-text-field>
                            <v-btn :disabled="$store.state.offline" v-can="{obj_type:'organism', action: 'edit'}" class="d-flex" color="primary" @click="editOrg(null)"><v-icon class="pa-2" small>add_box</v-icon>Nuovo ente</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
            <div v-if="!searching">
                <div v-if="objects.length==0" class="text-center">
                    <p class="display-1">Nessun ente</p>
                </div>
                <v-data-table
                    v-else
                    :headers="headers"
                    :items="objects"
                    :search="filter.search"
                    class="elevation-1"
                    hide-default-footer
                    disable-pagination>
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-can="{obj_type:'organism', action: 'view'}" v-for="(item,index) of items" :key="index" @click.stop="goToOrgDetails(item._id)" class="my-2">
                            <td class="text-left"><b>{{item.value.name}}</b></td>
                            <td class="text-left">{{item.value.piva}}</td>
                            <td class="text-right">
                                <span>
                                    <v-btn :disabled="$store.state.offline" v-can="{obj_type:'organism', action: 'edit'}" color="primary" @click.stop="editOrg(item._id, index)" fab small><v-icon class="ma-2" small>create</v-icon></v-btn>
                                    <v-btn :disabled="$store.state.offline || true" v-can="{obj_type:'organism', action: 'edit'}" color="primary" @click.stop="deleteOrg(item._id)" fab small><v-icon class="ma-2" small>delete</v-icon></v-btn>
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </template>                
                </v-data-table>
            </div>
        </BasicCard>
        <div v-if="objects.length > 0" class="text-center pa-2">
            <div class="text-right font-italic font-small">Totale: {{ objects.length }}</div>
        </div>
        <OrgsDialog
            ref="orgs_dialog"
            v-on:saveOrg="saveOrg"
        />
        <!--BaseDialog 
            :max_width="`600`"
            :dialog="defOrgs_dialog.show"
            title="Scegli ente default"
            v-on:close_dialog="defOrgs_dialog.show = false">
            <v-autocomplete
                :items="objects"
                item-value="_id"
                item-text="value.name"
                v-model="defOrgs_dialog.sel_org_id">
            </v-autocomplete>
            <template v-slot:action>
                <div class="d-flex align-center justify-center my-4">
                    <v-btn color="primary" v-on:click="saveDefaultOrg">salva</v-btn>
                    <v-btn text class="ml-4" v-on:click="defOrgs_dialog.show = false">Chiudi</v-btn>
                </div>
            </template>
        </BaseDialog-->
    </div>
        
</template>
<script>
    import OrgsDialog from "./OrgsDialog"
    // import _ from 'lodash'
    import {ListManagement} from "../../utils/listMixin"
    import BasicCard from '../../components/utils/Basic_card'
    import BaseDialog from '../../components/dialogs/BaseDialog'


    export default {
        components: {BasicCard, OrgsDialog, BaseDialog},
        name: 'orgs',
        mixins: [ListManagement],
        data() {
            return {
                headers: [
                    {text: "Riferimento", value: "value.name", align: "left"},
                    {text: "Partita iva", value: "name.piva", align: "left"},
                    {text: "", value: "actions", align: "left"},
                ],
                current_modified_idx: -1,
                filter: {
                    search: null
                },
                sort_fields:  {value: ['value.name'], order: ['asc']},
                searching: true,
                db: 'registry',
                def_orgs: [],
                defOrgs_dialog: {
                    show: false,
                    old_org_id: null,
                    sel_org_id: null
                },
                list_type: 'organism'
            }
        },
        async beforeMount() {
            let filter = this.$store.state.search[this.$router.history.current.fullPath]
            if (filter) {
                this.filter = Object.assign({}, this.filter, filter)
            }
            await this.updateSearch()
        },
        methods: {
            editOrg(org_id,idx){
                this.current_modified_idx = idx;
                this.$refs.orgs_dialog.reset(org_id);
                console.log("DEBUG INDEX", this.current_modified_idx)
            },
            deleteOrg(id){
                console.log("TO BE IMPLEMENTED", id);
            },
            async saveOrg(){
                await this.updateSearch()
            },
            goToOrgDetails(id){
                this.$store.commit('setSearchParam', { path: this.$router.history.current.fullPath, filter: this.filter })
                this.$router.push({name: 'orgDetails', query:{org_id: id, back: this.$router.history.current.fullPath}})
            },
            async updateSearch(){
                this.searching = true
                let res = await this.searchFromDesignNew('registry/searchByData', 'key', "organism", false)
                this.def_orgs = res.filter((org) =>  {

                    return org.value.emission_enabled
                })
                /*if (this.def_orgs.length>0) {
                    this.defOrgs_dialog.sel_org_id = this.def_orgs[0]._id
                } else {
                    this.defOrgs_dialog.sel_org_id = null
                }
                console.log(this.def_orgs)*/
                this.objects = this.orderBy(res, this.sort_fields)
                this.searching = false
            },
            /* async saveDefaultOrg() {
                console.log("*****", this.defOrgs_dialog.old_org_id, this.defOrgs_dialog.sel_org_id)
                if (this.defOrgs_dialog.old_org_id != this.defOrgs_dialog.sel_org_id) {
                    let sel = await this.$store.state.$pouch.get('registry', this.defOrgs_dialog.sel_org_id)
                    sel.emission_enabled = true
                    sel.updated = (new Date()).getTime()
                    sel.updated_by = this.$store.state.user._id
                    let doc_to_save = [sel]
                    if (this.defOrgs_dialog.old_org_id) {
                        let old = await this.$store.state.$pouch.get('registry', this.defOrgs_dialog.old_org_id)
                        old.emission_enabled = false
                        old.updated = sel.updated
                        old.updated_by = sel.updated_by
                        doc_to_save.push(old)
                    }
                    let res = await this.$store.state.$pouch.bulkDocs('registry', doc_to_save)
                }
                await this.updateSearch()
                this.defOrgs_dialog.show = false
            },
            openDefOrgsDialog() {
                this.defOrgs_dialog.old_org_id = null
                if (this.def_orgs.length > 0){
                    this.defOrgs_dialog.old_org_id = this.def_orgs[0]._id
                }
                this.defOrgs_dialog.show = true
            } */
        }
    }
</script>